import { connect } from 'react-redux'
import Screenfull from 'screenfull'
import { setPaused, setOrientationChecked } from 'macguffin/redux/actions'
import { getParameterByName } from 'macguffin/Utils'
import bowser from 'bowser'

@connect(state => ({
  session: state.session,
  dimensions: state.UI.dimensions,
}), { setOrientationChecked, setPaused })
export default class Fullscreen extends React.Component {
  state = {
    currentKey: 0,
  }

  componentDidMount() {
    const { session } = this.props
    const ignoreFullscreen = session.fullscreen === 'false'
    if (worksLikeApp() || ignoreFullscreen || Screenfull.isFullscreen) {
      this.props.setOrientationChecked(true)
      return
    }

    if (bowser.ios) {
      if (this.props.dimensions.portrait) {
        this.props.setOrientationChecked(true)
      } else {
        window.addEventListener('scroll', this.scrollToTop)
        this.props.setPaused(true)
        this.setState({ currentKey: 0 })
      }
    } else {
      document.addEventListener('click', this.requestFull)
      Screenfull.on('change', this.onFullscreenChanged)
    }
  }

  scrollToTop = () => {
    this.scrollTimeout && clearTimeout(this.scrollTimeout)
    this.scrollTimeout = setTimeout(() => window.scrollTo(0, 0), 500)
  }

  componentWillUnmount() {
    const { session } = this.props
    const ignoreFullscreen = session.fullscreen === 'false'
    if (worksLikeApp() || ignoreFullscreen) {
      return
    }

    if (bowser.ios) {
      window.removeEventListener('scroll', this.scrollToTop)
      this.props.setPaused(false)
    } else {
      document.removeEventListener('click', this.requestFull)
      Screenfull.off('change', this.onFullscreenChanged)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (bowser.ios && nextProps.dimensions !== this.props.dimensions) {
      if (nextProps.dimensions.portrait) {
        this.props.setOrientationChecked(true)
      }
    }
  }

  requestFull = () => {
    Screenfull.request()
  }

  onFullscreenChanged = () => {
    this.props.setOrientationChecked(true)
  }

  generateKey = () => {
    const { state } = this
    const { currentKey } = state

    this.setState({ currentKey: currentKey + 1 })
    this.forceUpdate()
  }

  swipeOverlay = () => {
    const { state } = this
    const { currentKey } = state

    return (
      <div className="swipe ios">
        <div className="sprite-swipe" />
      </div>
    )
  }

  render() {
    if (bowser.ios && !this.props.dimensions.portrait) {
      return (
        <div className="pleaOverlay">
          { this.swipeOverlay() }
        </div>
      )
    }
    return <div />
  }
}

function worksLikeApp() {
  //If game is saved to home screen
  if (window.navigator.standalone) {
    return true
  }


  //if OS not equal to iOS and Android
  if (!bowser.ios && !bowser.android) {
    return true
  }

  //If it's an iOS WebView or UnibetCasino app
  if (isWebview() || isCasino()) {
    return true
  }

  const clientid = getParameterByName('clientid')
  if (clientid && isIosAndroidPokerClient(clientid)) {
    return true
  }

  //If not Chrome or Firefox or Safari
  if (!bowser.chrome && !bowser.firefox && !bowser.safari && !bowser.samsungBrowser) {
    return true
  }

  // If something else than Safari on iOS
  if (bowser.ios && !bowser.safari) {
    return true
  }

  return false
}

const isIosAndroidPokerClient = clientid => /(ios|android)/i.test(clientid)
const isWebview = () => /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)
const isCasino = () => /(Casino)/i.test(navigator.userAgent)
